
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { MailOutlined, LockOutlined } from "@ant-design/icons";
import {
  Alert,
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  message,
  Row,
  Typography,
} from "antd";
import Link from "next/link";
import Router, { useRouter } from "next/router";
import AuthLayout from "../layouts/auth.layout";
import { signUp } from "../services/auth.service";
import GoogleLogoSVG from "../public/images/googleIcon.svg";
import { useState } from "react";

import EmailSVG from "../public/images/email.svg";
import PasswordSVG from "../public/images/password.svg";
import { ErrorMessageIcon, SuccessMessageIcon } from "../constants/icons";
import useTranslation from "next-translate/useTranslation";

const { Title, Text } = Typography;

const API_URL = process.env.NEXT_PUBLIC_APP_API_URL!;

const SignUp = () => {
  const { t, lang } = useTranslation("signup");
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(false);
  const [areTermsAccepted, setAreTermsAccepted] = useState(false);

  const [form] = Form.useForm();

  const handleAcceptTermsChanged = (e: any) => {
    setAreTermsAccepted(e.target.checked);
  };

  const onFinish = async (values: any) => {
    try {
      setIsLoading(true);
      const result = await signUp(values);

      if (result.data.user != null) {
        message.success({
          icon: (
            <div>
              <SuccessMessageIcon />
            </div>
          ),
          content: t("signup-success"),
        });

        Router.push("/login");
      }
    } catch (e: any) {
      if (
        e?.response?.data?.error?.status === 400 &&
        e?.response?.data?.error?.message === "Email is already taken"
      ) {
        message.error({
          icon: (
            <div>
              <ErrorMessageIcon />
            </div>
          ),
          content: t("already-email"),
        });
      } else {
        message.error({
          icon: (
            <div>
              <ErrorMessageIcon />
            </div>
          ),
          content:
            e?.response?.data?.error?.message || e?.message || "Unknown Error",
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const onGoogleLogin = () => {
    window.location.href = `${API_URL}/connect/google`;
  };

  const defaultValue = { username: "", email: "", password: "" };

  return (
    <>
      <div style={{ textAlign: "center" }}>
        <Text style={{ fontSize: "28px", fontFamily: "Inter" }}>
          {t("create")}
        </Text>
      </div>
      {/* <Title level={1}>Sign Up</Title>
        <Text type="secondary" style={{ fontSize: "1.5em" }}>
          {currentLocale.signUpPage.enterCredentials}
        </Text> */}
      <Button
        disabled={!areTermsAccepted}
        icon={<GoogleLogoSVG />}
        onClick={onGoogleLogin}
        type="primary"
        htmlType="submit"
        style={{
          width: "100%",
          height: "40px",
          fontSize: "16px",
          color: "black",
          backgroundColor: "white",
          borderColor: "lightgrey",
          marginTop: "3%",
          marginBottom: "3%",
          borderRadius: "8px",
          justifyContent: "center",
          display: "inline-flex",
          alignItems: "center",
        }}
      >
        <Text style={{ padding: "0px 10px 0px 10px" }}> {t("google")}</Text>
      </Button>
      {areTermsAccepted === false ? (
        <Alert
          message={
            <Text style={{ fontSize: "12px" }}>{t("terms-warning")}</Text>
          }
          type="warning"
          showIcon
        />
      ) : (
        <></>
      )}
      <Divider plain style={{ color: "lightgrey", fontSize: "10px" }}>
        {t("or")}
      </Divider>
      <Form
        onFinish={onFinish}
        layout="vertical"
        form={form}
        initialValues={defaultValue}
      >
        <Form.Item
          hasFeedback
          name="email"
          // label="E-mail"
          rules={[
            {
              type: "email",
              message: t("invalid-email"),
            },
            {
              required: true,
              message: t("input-email"),
            },
          ]}
        >
          <Input
            id="signUpEmailInput"
            // prefix={<MailOutlined className="site-form-item-icon" />}
            prefix={<EmailSVG />}
            placeholder={t("email-placeholder")}
            style={{
              borderRadius: "8px",
              height: "45px",
              fontSize: "16px",
            }}
          ></Input>
        </Form.Item>

        <Form.Item
          name="password"
          // label="Password"
          hasFeedback
          rules={[
            {
              required: true,
              message: t("input-password"),
            },

            /*  {
                pattern: new RegExp(
                  "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$"
                ),
                message: `Your password must contain minimum 8 characters, both uppercase and lowercase letters, at least one digit, at least one special character`,
              }, */
            {
              pattern: new RegExp("^(?=.*?[a-zA-Z])(?=.*?[0-9]).{8,}$"),
              message: t("pass-validation"),
            },
          ]}
        >
          <Input.Password
            id="signUpPasswordInput"
            // prefix={<LockOutlined className="site-form-item-icon" />}
            prefix={<PasswordSVG />}
            placeholder={t("password-placeholder")}
            style={{
              borderRadius: "8px",
              height: "45px",
              fontSize: "16px",
            }}
          ></Input.Password>
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          // label="Re-type Password"
          dependencies={["password"]}
          hasFeedback
          rules={[
            {
              required: true,
              message: t("input-confirm"),
            },
            ({ getFieldValue }) => ({
              validator(rule, value) {
                if (!value || getFieldValue("password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  // currentLocale.signUpPage.passwordMismatchError
                  t("pass-mismatch")
                );
              },
            }),
          ]}
        >
          <Input.Password
            id="signUpConfirmPasswordInput"
            // prefix={<LockOutlined className="site-form-item-icon" />}
            prefix={<PasswordSVG />}
            placeholder={t("confirm-placeholder")}
            style={{
              borderRadius: "8px",
              height: "45px",
              fontSize: "16px",
            }}
          ></Input.Password>
        </Form.Item>

        {/* toc and privacy policy */}
        <Row style={{ justifyContent: "space-between" }}>
          <Form.Item
            name="acceptTerms"
            valuePropName="checked"
            hasFeedback
            rules={[
              {
                validator: (_, value) =>
                  value
                    ? Promise.resolve()
                    : Promise.reject(new Error(t("terms-warning"))),
              },
            ]}
          >
            <Checkbox
              onChange={handleAcceptTermsChanged}
              style={{ fontSize: "12px" }}
            >
              <span>{`${t("have-read")} `}</span>
              <Link href="https://www.leadsnow.app/terms-of-use">
                <a
                  target="_blank"
                  style={{ color: "#1890ff", marginRight: "5px" }}
                >
                  {t("tos")}
                </a>
              </Link>
              <span style={{ marginRight: "5px" }}>&</span>
              <Link href="https://www.leadsnow.app/privacy-policy">
                <a target="_blank" style={{ color: "#1890ff" }}>
                  {t("privacy")}
                </a>
              </Link>
            </Checkbox>
          </Form.Item>
        </Row>

        <Form.Item>
          <Button
            loading={isLoading}
            type="primary"
            htmlType="submit"
            style={{
              width: "100%",
              height: "40px",
              fontSize: "18px",
              borderRadius: "8px",
            }}
          >
            {/* {currentLocale.signUpPage.signUp} */}
            {t("signup")}
          </Button>
        </Form.Item>
      </Form>
      <div style={{ fontSize: "16px" }}>
        {t("already-use")}
        <Link href="/login">
          {/* <a style={{ color: "#1890ff" }}>{currentLocale.signUpPage.login}</a> */}
          <a style={{ color: "#1890ff" }}>{` ${t("signin")}`}</a>
        </Link>
      </div>
      <div style={{ marginTop: "20px", fontSize: "12px" }}>
        <Text style={{ color: "#585757" }}>© 2022 Leadsnow Oy</Text>
      </div>
    </>
  );
};
SignUp.layout = AuthLayout;
export default SignUp;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/signup',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  